import React from 'react'
import classNames from 'classnames'
import kebabCase from 'lodash.kebabcase'
import { Text } from 'marketing-site/src/library/elements/Text'
import { IProps } from './index'
import { RichText } from 'marketing-site/src/mvp/library/elements/RichText'
import { CTALink } from 'marketing-site/src/sass-components/library/elements/CTALink'
import { CTATheme } from 'marketing-site/src/mvp/library/utils'
import styles from './styles.module.scss'

export const PreFooterCTABlock: React.FC<IProps> = ({
  eyebrow,
  title,
  subhead,
  ctas,
  width = 'inset',
  backgroundColor = 'transparent',
  checkmarks,
  linkText,
}) => {
  const classes = classNames(styles['pre-footer'], 'pre-footer', 'grid-layout', {
    [`mvp-background-color-${kebabCase(backgroundColor)}`]: backgroundColor,
    [styles['pre-footer__inset']]: width === 'inset',
    [styles['pre-footer__fullWidth']]: width !== 'inset',
  })

  const innerClasses = classNames(styles['pre-footer__inner'], 'pre-footer__inner')

  const ctaClassNames = classNames(styles['pre-footer__ctas'], 'pre-footer__ctas', {
    [styles['pre-footer__ctas__multi-cta-gap']]: ctas.length > 1,
    [styles['pre-footer__ctas__single-cta-gap']]: ctas.length <= 1,
    [styles['pre-footer__ctas__flex-row']]: ctas.length > 1,
    [styles['pre-footer__ctas__flex-column']]: ctas.length <= 1,
  })

  const ctaColor =
    backgroundColor === 'blue' || backgroundColor === 'slate' || backgroundColor === 'deepTeal'
      ? CTATheme.LinkOnlyPaper
      : CTATheme.LinkOnlySlate

  return (
    <>
      <div className={classes}>
        <div className={innerClasses}>
          <div className={styles['pre-footer__content']}>
            {eyebrow && (
              <div className={styles['pre-footer__eyebrow']}>
                <Text size="eyebrow">{eyebrow}</Text>
              </div>
            )}
            <div className={styles['pre-footer__title']}>
              <Text size="heading-3">{title}</Text>
            </div>
            {subhead && (
              <div className={styles['pre-footer__subhead']}>
                <Text size="subhead-sm">{subhead}</Text>
              </div>
            )}
            {linkText && (
              <div className={styles['pre-footer__link-text']}>
                <CTALink {...linkText} variant={ctaColor} />
              </div>
            )}
          </div>
          <div className={ctaClassNames}>
            {!!ctas && ctas}
            {checkmarks && (
              <div className={styles['pre-footer__checkmarks']}>
                <Text size="caption">
                  <RichText document={checkmarks} />
                </Text>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
